import { useEffect, useState } from 'react';
import { viewportSafeAreaInsetTop, viewportContentSafeAreaInsetTop, isTMA } from '@telegram-apps/sdk';

const TMA_MIN_INSET_PX = 96;

const inTMA = (() => {
  try {
    return isTMA();
  } catch {
    return false;
  }
})();

const read = (): number => {
  try {
    const sum = (viewportSafeAreaInsetTop?.() ?? 0) + (viewportContentSafeAreaInsetTop?.() ?? 0);
    return inTMA ? Math.max(sum, TMA_MIN_INSET_PX) : sum;
  } catch {
    return 0;
  }
};

export function useTelegramTopInset(): number {
  const [inset, setInset] = useState<number>(read);

  useEffect(() => {
    const update = () => setInset(read());
    let unsubA: (() => void) | undefined;
    let unsubB: (() => void) | undefined;
    try {
      unsubA = viewportSafeAreaInsetTop.sub(update);
      unsubB = viewportContentSafeAreaInsetTop.sub(update);
    } catch {
      // SDK not initialized (non-Telegram env) — fallback handled by caller
    }
    update();
    return () => {
      unsubA?.();
      unsubB?.();
    };
  }, []);

  return inset;
}
